import type { CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';

/** Toasts confirm and inform without blocking; anything that needs a decision also lives in the UI. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-center"
      // Just above the room's control bar, clear of the stage toolbar (Stop control, Keys) at the
      // top; on phones, full width with small side margins.
      offset={{ bottom: 84 }}
      mobileOffset={{ bottom: 76, left: 12, right: 12 }}
      style={{ '--width': '24rem' } as CSSProperties}
      gap={8}
      visibleToasts={3}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            // Width comes from sonner (--width on desktop, full width minus margins on phones).
            'group flex items-start gap-3 rounded-lg border border-line bg-raised p-3.5 text-compact text-ink-2 shadow-md',
          title: 'font-medium text-ink',
          description: 'mt-0.5 text-label text-ink-3',
          icon: 'mt-0.5 shrink-0 [&_svg]:size-4',
          success: '[&_[data-icon]]:text-success-text',
          error: '[&_[data-icon]]:text-danger-text',
          warning: '[&_[data-icon]]:text-warning-text',
          info: '[&_[data-icon]]:text-ink-3',
          actionButton:
            'ml-auto h-8 shrink-0 cursor-pointer rounded-sm bg-accent px-3 text-label font-medium text-accent-ink hover:bg-accent-hover',
          cancelButton: 'h-8 shrink-0 cursor-pointer rounded-sm px-3 text-label font-medium text-ink-2 hover:bg-hover',
          content: 'min-w-0 flex-1',
        },
      }}
    />
  );
}
